import React from 'react';

const ImpressumPage = () => (
  <main style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto' }}>
    <h1>Impressum</h1>
    <div style={{ whiteSpace: 'pre-line', lineHeight: '1.6' }}>
      Angaben gemäß § 5 TMG  
      Firmenname: Chiara Körner  
      Inhaber: Chiara Körner  
      Adresse: Lodenweg 6  
      PLZ und Stadt: 59581 Warstein  
      E-Mail: ckorner32@gmail.com  
      Tel: 01784590988  
      Nach § 19 UStG (Kleinunternehmerregelung) weist Chiara Körner keine Umsatzsteuer in ihren Rechnungen aus.  

      Inhaltlich Verantwortlicher gemäß § 5 TMG:  
      Name: Chiara Körner  
      E-Mail: ckorner32@gmail.com  

      Inhaltlich Verantwortlicher gemäß § 18 Abs. 2 MStV  
      Name: Chiara Körner  
      E-Mail: ckorner32@gmail.com  

      Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit, die Sie unter  
      https://ec.europa.eu/consumers/odr finden.  

      Zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle sind wir nicht verpflichtet und nicht bereit.  

      Dieses Impressum gilt auch für folgende Onlinepräsenzen:  
      Facebook: https://www.facebook.com/people/Chiara-K%C3%B6rner/100054265730255/  
      Instagram: https://www.instagram.com/chiarak_oerner/
    </div>
  </main>
);

export default ImpressumPage;
